import styled from 'styled-components';
import FlightActiveHeadSvg from '../../assets/header/flight-active.svg';

const FlightActiveHeadIcon = styled(FlightActiveHeadSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '3.3rem'};
height: ${props => props.height || '3.3rem'};
margin: ${props => props.margin};
fill: ${props => props.fill};
`;

export default FlightActiveHeadIcon;
